module.exports = __webpack_public_path__ + "static/img/coming_soon.faa1f92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2023/coming_soon.jpg
// module id = MdpB
// module chunks = 4